<his-documentation-link
	[target]="moduleOptions.DOCUMENTATION_ARTICLE"
	[title]="moduleOptions.DOCUMENTATION_TITLE">
</his-documentation-link>

<h1>{{ 'fs.res.publication.duplicates.search' | hisUi }}</h1>
<p></p>

<div class="layoutBlock">
	<div class="columnHalf">
		
		<p-panel>
			<h2>{{ 'fs.res.publication.duplicates.search.header' | hisUi }}</h2>
    		<p></p>
    		
    		<button (click)="doSearch()" hisImage="LINE_OUT" class="transparent"><span>{{ 'fs.res.publication.duplicates.search.start' | hisUi }}</span></button>
		</p-panel>
	</div>
</div>
